export default __webpack_public_path__ + "static/media/ecarm.0ee4e5d4.jpg";